"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMessageBarActionsContextValue_unstable", {
    enumerable: true,
    get: function() {
        return useMessageBarActionsContextValue_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useMessageBarActionsContextValue_unstable() {
    const buttonContext = _react.useMemo(()=>({
            size: 'small'
        }), []);
    return {
        button: buttonContext
    };
}
